const NAME = 'notifications';

const USER_ALERTS_MODULES = {
  MESSAGING: 'messaging',
};

const USER_ALERTS_MESSAGING = {
  AUTO_MESSAGES_SETTINGS_GUIDE: 'auto_messages_settings_guide',
  AUTO_RESPONSES_SETTINGS_GUIDE: 'auto_responses_settings_guide',
  AUTO_RESPONSES_SETTINGS_TASKS: 'auto_responses_settings_tasks',
};

const NOTIFICATION_POSITION = {
  CENTER: 'center',
  RIGHT: 'right',
};

export default { NAME, USER_ALERTS_MODULES, USER_ALERTS_MESSAGING, NOTIFICATION_POSITION };
